/**
 * Generated by orval v7.13.2 🍺
 * Do not edit manually.
 * Internal API
 * OpenAPI spec version: v1
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query';

import type {
  AddAbsenceRequest,
  AddDutyRosterShift,
  DepartmentDutyRosterGetFormulaResultsParams,
  DepartmentDutyRosterGetParams,
  DepartmentDutyRosterGetShiftParams,
  DepartmentDutyRosterResult,
  DutyShiftDto,
  EditDutyRosterShift,
  StringFormulaResultDictionaryWrapper
} from '../../model';

import { customInstance } from '../../../mutator';
import type { ErrorType , BodyType } from '../../../mutator';


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



export const getDepartmentDutyRosterGetUrl = (params?: DepartmentDutyRosterGetParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["departmentIds","workareaIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DepartmentDutyRoster/Get?${stringifiedParams}` : `/api/DepartmentDutyRoster/Get`
}

export const departmentDutyRosterGet = async (params?: DepartmentDutyRosterGetParams, options?: RequestInit): Promise<DepartmentDutyRosterResult> => {
  
  return customInstance<DepartmentDutyRosterResult>(getDepartmentDutyRosterGetUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDepartmentDutyRosterGetQueryKey = (params?: DepartmentDutyRosterGetParams,) => {
    return [
    `/api/DepartmentDutyRoster/Get`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDepartmentDutyRosterGetQueryOptions = <TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDepartmentDutyRosterGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof departmentDutyRosterGet>>> = ({ signal }) => departmentDutyRosterGet(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DepartmentDutyRosterGetQueryResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterGet>>>
export type DepartmentDutyRosterGetQueryError = ErrorType<unknown>


export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params: undefined |  DepartmentDutyRosterGetParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentDutyRosterGet>>,
          TError,
          Awaited<ReturnType<typeof departmentDutyRosterGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentDutyRosterGet>>,
          TError,
          Awaited<ReturnType<typeof departmentDutyRosterGet>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDepartmentDutyRosterGet<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDepartmentDutyRosterGetQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDepartmentDutyRosterGetSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDepartmentDutyRosterGetQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof departmentDutyRosterGet>>> = ({ signal }) => departmentDutyRosterGet(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DepartmentDutyRosterGetSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterGet>>>
export type DepartmentDutyRosterGetSuspenseQueryError = ErrorType<unknown>


export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params: undefined |  DepartmentDutyRosterGetParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDepartmentDutyRosterGetSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGet>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDepartmentDutyRosterGetSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDepartmentDutyRosterAddAbsenceUrl = () => {


  

  return `/api/DepartmentDutyRoster/AddAbsence`
}

export const departmentDutyRosterAddAbsence = async (addAbsenceRequest: AddAbsenceRequest, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDepartmentDutyRosterAddAbsenceUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addAbsenceRequest,)
  }
);}




export const getDepartmentDutyRosterAddAbsenceMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, TError,{data: BodyType<AddAbsenceRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, TError,{data: BodyType<AddAbsenceRequest>}, TContext> => {

const mutationKey = ['departmentDutyRosterAddAbsence'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, {data: BodyType<AddAbsenceRequest>}> = (props) => {
          const {data} = props ?? {};

          return  departmentDutyRosterAddAbsence(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DepartmentDutyRosterAddAbsenceMutationResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>>
    export type DepartmentDutyRosterAddAbsenceMutationBody = BodyType<AddAbsenceRequest>
    export type DepartmentDutyRosterAddAbsenceMutationError = ErrorType<unknown>

    export const useDepartmentDutyRosterAddAbsence = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>, TError,{data: BodyType<AddAbsenceRequest>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof departmentDutyRosterAddAbsence>>,
        TError,
        {data: BodyType<AddAbsenceRequest>},
        TContext
      > => {

      const mutationOptions = getDepartmentDutyRosterAddAbsenceMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getDepartmentDutyRosterAddShiftUrl = () => {


  

  return `/api/DepartmentDutyRoster/AddShift`
}

export const departmentDutyRosterAddShift = async (addDutyRosterShift: AddDutyRosterShift, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDepartmentDutyRosterAddShiftUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      addDutyRosterShift,)
  }
);}




export const getDepartmentDutyRosterAddShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, TError,{data: BodyType<AddDutyRosterShift>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, TError,{data: BodyType<AddDutyRosterShift>}, TContext> => {

const mutationKey = ['departmentDutyRosterAddShift'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, {data: BodyType<AddDutyRosterShift>}> = (props) => {
          const {data} = props ?? {};

          return  departmentDutyRosterAddShift(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DepartmentDutyRosterAddShiftMutationResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>>
    export type DepartmentDutyRosterAddShiftMutationBody = BodyType<AddDutyRosterShift>
    export type DepartmentDutyRosterAddShiftMutationError = ErrorType<unknown>

    export const useDepartmentDutyRosterAddShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterAddShift>>, TError,{data: BodyType<AddDutyRosterShift>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof departmentDutyRosterAddShift>>,
        TError,
        {data: BodyType<AddDutyRosterShift>},
        TContext
      > => {

      const mutationOptions = getDepartmentDutyRosterAddShiftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getDepartmentDutyRosterEditShiftUrl = () => {


  

  return `/api/DepartmentDutyRoster/EditShift`
}

export const departmentDutyRosterEditShift = async (editDutyRosterShift: EditDutyRosterShift, options?: RequestInit): Promise<void> => {
  
  return customInstance<void>(getDepartmentDutyRosterEditShiftUrl(),
  {      
    ...options,
    method: 'POST',
    headers: { 'Content-Type': 'application/json', ...options?.headers },
    body: JSON.stringify(
      editDutyRosterShift,)
  }
);}




export const getDepartmentDutyRosterEditShiftMutationOptions = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, TError,{data: BodyType<EditDutyRosterShift>}, TContext>, request?: SecondParameter<typeof customInstance>}
): UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, TError,{data: BodyType<EditDutyRosterShift>}, TContext> => {

const mutationKey = ['departmentDutyRosterEditShift'];
const {mutation: mutationOptions, request: requestOptions} = options ?
      options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey ?
      options
      : {...options, mutation: {...options.mutation, mutationKey}}
      : {mutation: { mutationKey, }, request: undefined};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, {data: BodyType<EditDutyRosterShift>}> = (props) => {
          const {data} = props ?? {};

          return  departmentDutyRosterEditShift(data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type DepartmentDutyRosterEditShiftMutationResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>>
    export type DepartmentDutyRosterEditShiftMutationBody = BodyType<EditDutyRosterShift>
    export type DepartmentDutyRosterEditShiftMutationError = ErrorType<unknown>

    export const useDepartmentDutyRosterEditShift = <TError = ErrorType<unknown>,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof departmentDutyRosterEditShift>>, TError,{data: BodyType<EditDutyRosterShift>}, TContext>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient): UseMutationResult<
        Awaited<ReturnType<typeof departmentDutyRosterEditShift>>,
        TError,
        {data: BodyType<EditDutyRosterShift>},
        TContext
      > => {

      const mutationOptions = getDepartmentDutyRosterEditShiftMutationOptions(options);

      return useMutation(mutationOptions, queryClient);
    }
    export const getDepartmentDutyRosterGetShiftUrl = (params?: DepartmentDutyRosterGetShiftParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DepartmentDutyRoster/GetShift?${stringifiedParams}` : `/api/DepartmentDutyRoster/GetShift`
}

export const departmentDutyRosterGetShift = async (params?: DepartmentDutyRosterGetShiftParams, options?: RequestInit): Promise<DutyShiftDto> => {
  
  return customInstance<DutyShiftDto>(getDepartmentDutyRosterGetShiftUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDepartmentDutyRosterGetShiftQueryKey = (params?: DepartmentDutyRosterGetShiftParams,) => {
    return [
    `/api/DepartmentDutyRoster/GetShift`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDepartmentDutyRosterGetShiftQueryOptions = <TData = Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError = ErrorType<unknown>>(params?: DepartmentDutyRosterGetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDepartmentDutyRosterGetShiftQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>> = ({ signal }) => departmentDutyRosterGetShift(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DepartmentDutyRosterGetShiftQueryResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>>
export type DepartmentDutyRosterGetShiftQueryError = ErrorType<unknown>


export function useDepartmentDutyRosterGetShift<TData = Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError = ErrorType<unknown>>(
 params: undefined |  DepartmentDutyRosterGetShiftParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentDutyRosterGetShift>>,
          TError,
          Awaited<ReturnType<typeof departmentDutyRosterGetShift>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetShift<TData = Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentDutyRosterGetShift>>,
          TError,
          Awaited<ReturnType<typeof departmentDutyRosterGetShift>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetShift<TData = Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDepartmentDutyRosterGetShift<TData = Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetShiftParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDepartmentDutyRosterGetShiftQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDepartmentDutyRosterGetShiftSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError = ErrorType<unknown>>(params?: DepartmentDutyRosterGetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDepartmentDutyRosterGetShiftQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>> = ({ signal }) => departmentDutyRosterGetShift(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DepartmentDutyRosterGetShiftSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>>
export type DepartmentDutyRosterGetShiftSuspenseQueryError = ErrorType<unknown>


export function useDepartmentDutyRosterGetShiftSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError = ErrorType<unknown>>(
 params: undefined |  DepartmentDutyRosterGetShiftParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetShiftSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetShiftSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDepartmentDutyRosterGetShiftSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetShiftParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetShift>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDepartmentDutyRosterGetShiftSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDepartmentDutyRosterGetFormulaResultsUrl = (params?: DepartmentDutyRosterGetFormulaResultsParams,) => {
  const normalizedParams = new URLSearchParams();

  Object.entries(params || {}).forEach(([key, value]) => {
    const explodeParameters = ["contractIds","formulaIds"];

    if (Array.isArray(value) && explodeParameters.includes(key)) {
      value.forEach((v) => {
        normalizedParams.append(key, v === null ? 'null' : v.toString());
      });
      return;
    }
      
    if (value !== undefined) {
      normalizedParams.append(key, value === null ? 'null' : value.toString())
    }
  });

  const stringifiedParams = normalizedParams.toString();

  return stringifiedParams.length > 0 ? `/api/DepartmentDutyRoster/GetFormulaResults?${stringifiedParams}` : `/api/DepartmentDutyRoster/GetFormulaResults`
}

export const departmentDutyRosterGetFormulaResults = async (params?: DepartmentDutyRosterGetFormulaResultsParams, options?: RequestInit): Promise<StringFormulaResultDictionaryWrapper> => {
  
  return customInstance<StringFormulaResultDictionaryWrapper>(getDepartmentDutyRosterGetFormulaResultsUrl(params),
  {      
    ...options,
    method: 'GET'
    
    
  }
);}





export const getDepartmentDutyRosterGetFormulaResultsQueryKey = (params?: DepartmentDutyRosterGetFormulaResultsParams,) => {
    return [
    `/api/DepartmentDutyRoster/GetFormulaResults`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getDepartmentDutyRosterGetFormulaResultsQueryOptions = <TData = Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError = ErrorType<unknown>>(params?: DepartmentDutyRosterGetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDepartmentDutyRosterGetFormulaResultsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>> = ({ signal }) => departmentDutyRosterGetFormulaResults(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DepartmentDutyRosterGetFormulaResultsQueryResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>>
export type DepartmentDutyRosterGetFormulaResultsQueryError = ErrorType<unknown>


export function useDepartmentDutyRosterGetFormulaResults<TData = Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError = ErrorType<unknown>>(
 params: undefined |  DepartmentDutyRosterGetFormulaResultsParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>,
          TError,
          Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetFormulaResults<TData = Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>,
          TError,
          Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>
        > , 'initialData'
      >, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetFormulaResults<TData = Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDepartmentDutyRosterGetFormulaResults<TData = Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetFormulaResultsParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDepartmentDutyRosterGetFormulaResultsQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getDepartmentDutyRosterGetFormulaResultsSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError = ErrorType<unknown>>(params?: DepartmentDutyRosterGetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getDepartmentDutyRosterGetFormulaResultsQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>> = ({ signal }) => departmentDutyRosterGetFormulaResults(params, { signal, ...requestOptions });

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type DepartmentDutyRosterGetFormulaResultsSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>>
export type DepartmentDutyRosterGetFormulaResultsSuspenseQueryError = ErrorType<unknown>


export function useDepartmentDutyRosterGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError = ErrorType<unknown>>(
 params: undefined |  DepartmentDutyRosterGetFormulaResultsParams, options: { query:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useDepartmentDutyRosterGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient
  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useDepartmentDutyRosterGetFormulaResultsSuspense<TData = Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError = ErrorType<unknown>>(
 params?: DepartmentDutyRosterGetFormulaResultsParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof departmentDutyRosterGetFormulaResults>>, TError, TData>>, request?: SecondParameter<typeof customInstance>}
 , queryClient?: QueryClient 
 ):  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getDepartmentDutyRosterGetFormulaResultsSuspenseQueryOptions(params,options)

  const query = useSuspenseQuery(queryOptions, queryClient) as  UseSuspenseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



